import { salesPortalApi } from '@/plugins/api-client';

import type { ISalesPortalBootstrapData } from '@condo/domain';

export const fetchBootstrapData = async (): Promise<ISalesPortalBootstrapData> => {
    return salesPortalApi.get('/dictionaries/bootstrap-data').then(response => response.data);
};
